import keys from '@debbie/common/dist/cache/keys.js';
import { CaseStatus } from '@debbie/common/dist/cases/index.js';
import { ErrorCannotMoveWrittenOffVoucher, effectiveBookingDate, enteredAmount, isAssociationManaged, } from '@debbie/common/dist/economy/case-vouchers/index.js';
import { isEngineV2Case } from '@debbie/common/dist/economy/helpers/policy.js';
import { countedAmounts } from '@debbie/common/dist/economy/helpers/vouchers.js';
import { ErrorYouAreAboutToMakePossibleUnintendedAdjustments, VoucherCategory, VoucherTypeIds, VoucherTypeSetting, } from '@debbie/common/dist/economy/vouchers/index.js';
import { isCalculatedInterest } from '@debbie/common/dist/economy/vouchers/setup.js';
import { Entity, Site, formatNumber } from '@debbie/common/dist/index.js';
import { isAdmin } from '@debbie/common/dist/permissions/index.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as caseVouchersAPI from '@debbie/cortex/dist/api/case-vouchers.js';
import { blameLogsEntity } from '@debbie/cortex/dist/blamelogs/index.js';
import { caseVouchersEntity } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useRole } from '@debbie/cortex/dist/me/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import moment from 'moment';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import { errorNotification, getErrorMessage } from '../../../utils/errors.js';
import { toPercent } from '../../../utils/index.js';
import Alert from '../../Alert.js';
import Button from '../../Button.js';
import CasePreviewByCaseId from '../../CasePreview/CasePreviewByCaseId.js';
import CopyToClipboard from '../../CopyToClipboard.js';
import DateInput from '../../DateInput.js';
import File from '../../File/index.js';
import FileDropzone from '../../FileDropzone.js';
import { Edit, X } from '../../Icons/index.js';
import Input from '../../Input.js';
import Money from '../../Money.js';
import MoneyInput from '../../MoneyInput.js';
import PerformedBy from '../../performed-by/PerformedBy.js';
import { shouldShowPerformedBy } from '../../performed-by/visibility.js';
import PlaceholderLoader from '../../PlaceholderLoader.js';
import Properties from '../../Properties/index.js';
import Search from '../../Search.js';
import SearchInput from '../../SearchInput.js';
import Table from '../../Table.js';
import TransactionAccountPreview from '../TransactionAccountPreview.js';
import TransactionImportPreview from '../TransactionImportPreview.js';
import PaymentType from './PaymentType.js';
const RenderNull = () => {
    return React.createElement("span", { style: { opacity: 0.6 } }, "-");
};
const CaseVoucherInfoMeta = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const site = useSelector((s) => s.site);
    const meRole = useRole();
    const isMeAdmin = meRole && isAdmin(meRole);
    const dropzoneRef = useRef(null);
    const [duplicates, setDuplicates] = useState(null);
    const { caseVoucher, caseVouchers, singleCase } = props;
    const engineV2 = singleCase != null && isEngineV2Case(singleCase);
    // A voucher partly or fully written off shows its entered amount, which is
    // the one edited, beside what is left of it. Calculated interest has no
    // entered amount.
    const { originalAmount, writtenOffAmount } = countedAmounts(caseVoucher);
    const writtenDown = originalAmount !== null && writtenOffAmount !== 0;
    const updateAppendix = useMutation((appendix) => caseVouchersAPI.patchCaseVoucher(caseVoucher.caseVoucherId, { appendix }), {
        onSuccess: () => {
            q.invalidate(keys.write.modify(caseVouchersEntity, caseVoucher.caseVoucherId));
        },
        onError: (error) => {
            console.error(error);
            errorNotification(lang, error, 'update', lang.errorEntities.caseVoucher);
        },
    });
    const referencingCaseVoucher = caseVouchers && caseVoucher.referenceCaseVoucherId
        ? caseVouchers.find((v) => v.caseVoucherId === caseVoucher.referenceCaseVoucherId)
        : null;
    const checkForDuplicates = async (reference) => {
        if (singleCase &&
            reference &&
            caseVoucher.voucherTypeId &&
            reference !== caseVoucher.referenceId) {
            const matches = await caseVouchersAPI.checkForDuplicates(singleCase.creditorId, [
                {
                    referenceId: reference,
                    voucherTypeId: caseVoucher.voucherTypeId,
                },
            ]);
            setDuplicates(matches);
        }
    };
    return (React.createElement(Meta, null,
        duplicates && !!duplicates.length && (React.createElement(Alert, { message: React.createElement(React.Fragment, null,
                lang.economyVoucherTypeLabels[caseVoucher.voucherTypeId],
                ' ',
                duplicates[0].referenceId,
                " ",
                lang.economy.voucherAlreadyExists,
                ' ',
                duplicates.map((match, index) => (React.createElement(React.Fragment, null,
                    React.createElement(Link, { style: {
                            color: 'inherit',
                        }, to: `/cases/${match.caseSeqId}` }, match.caseSeqId),
                    duplicates.length - 1 !== index && ', ')))) })),
        React.createElement(FileDropzone, { onChange: (file) => updateAppendix.mutate(file), dropzoneRef: dropzoneRef },
            React.createElement("h3", null, lang.economy.caseVoucherInfoHeaderTheVoucher),
            React.createElement(Table, { zebra: true },
                React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.caseVoucherInfoType),
                    React.createElement(TdValue, null,
                        React.createElement("b", null, lang.economyVoucherTypeLabels[caseVoucher.voucherTypeId] || caseVoucher.label),
                        ' ',
                        React.createElement(PaymentType, { paymentType: caseVoucher.paymentType }),
                        ' ',
                        caseVoucher.state && lang.caseVoucherStates[caseVoucher.state],
                        isMeAdmin && (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            React.createElement(Link, { to: `/settings/economy/case-voucher-types/${caseVoucher.voucherTypeId}`, style: {
                                    color: THEME.COLOR_ACCENT,
                                    textDecoration: 'none',
                                    fontWeight: 900,
                                    fontSize: '0.7em',
                                } }, lang.economy.caseVoucherInfoTypeSeeDetails))))),
                React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.referenceId),
                    React.createElement(TdValue, null,
                        React.createElement(EditHandler, { singleCase: singleCase, placeholder: lang.economy.referenceId, editKey: "referenceId", editType: EditType.String, caseVoucher: caseVoucher, onChange: (value) => checkForDuplicates(value) },
                            React.createElement("b", null, caseVoucher.referenceId ? (React.createElement(CopyToClipboard, { text: caseVoucher.referenceId }, caseVoucher.referenceId)) : (React.createElement(RenderNull, null)))))),
                React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.voucherInfoText),
                    React.createElement(TdValue, null,
                        React.createElement(EditHandler, { singleCase: singleCase, placeholder: lang.economy.text, editKey: "text", editType: EditType.String, caseVoucher: caseVoucher },
                            React.createElement("b", null, caseVoucher.text || React.createElement(RenderNull, null))))),
                caseVoucher.date &&
                    ![
                        VoucherTypeSetting.CompoundInterest,
                        VoucherTypeSetting.InterestFromTable,
                        VoucherTypeSetting.InterestPercentage,
                    ].includes(caseVoucher.setting) && (React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.date),
                    React.createElement(TdValue, null, caseVoucher.category === VoucherCategory.TRANSACTION ? (React.createElement("b", null, moment(caseVoucher.date).format(THEME.DATE_FORMAT_SHORT))) : (React.createElement(EditHandler, { singleCase: singleCase, placeholder: lang.economy.date, editKey: "date", editType: EditType.Date, caseVoucher: caseVoucher, notNullable: true },
                        React.createElement("b", null, moment(caseVoucher.date).format(THEME.DATE_FORMAT_SHORT))))))),
                caseVoucher.category === VoucherCategory.TRANSACTION.valueOf() && (React.createElement("tr", null,
                    React.createElement(TdKey, { title: lang.caseVouchers.bookingDateDescription }, lang.caseVouchers.bookingDate),
                    React.createElement(TdValue, null, (() => {
                        const value = (React.createElement(React.Fragment, null,
                            React.createElement("b", null, moment(effectiveBookingDate(caseVoucher)).format(THEME.DATE_FORMAT_SHORT)),
                            ' ',
                            caseVoucher.bookingDate == null && (React.createElement("small", null,
                                "(",
                                lang.caseVouchers.bookingDateFollowsDate,
                                ")"))));
                        // The association sync owns managed vouchers and the server
                        // rejects direct edits, so do not offer one
                        return isAssociationManaged(caseVoucher) ? (value) : (React.createElement(EditHandler, { singleCase: singleCase, placeholder: lang.caseVouchers.bookingDate, editKey: "bookingDate", editType: EditType.Date, preProcessValue: () => effectiveBookingDate(caseVoucher), caseVoucher: caseVoucher }, value));
                    })()))),
                caseVoucher.category === VoucherCategory.PRINCIPAL && (React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.dueDate),
                    React.createElement(TdValue, null,
                        React.createElement(EditHandler, { singleCase: singleCase, placeholder: lang.economy.dueDate, editKey: "dueDate", editType: EditType.Date, caseVoucher: caseVoucher, minDate: new Date(caseVoucher.date) },
                            React.createElement("b", null, caseVoucher.dueDate
                                ? moment(caseVoucher.dueDate).format(THEME.DATE_FORMAT_SHORT)
                                : '-'),
                            ' ',
                            caseVoucher.dueDate &&
                                new Date(caseVoucher.dueDate).getTime() -
                                    new Date(caseVoucher.date).getTime() >
                                    1000 * 60 * 60 * 24 && (React.createElement(React.Fragment, null,
                                "(",
                                moment
                                    .duration(moment(caseVoucher.dueDate)
                                    .startOf('day')
                                    .diff(moment(caseVoucher.date).startOf('day')))
                                    .humanize(),
                                ")")))))),
                (writtenDown || !!caseVoucher.amount) && (React.createElement("tr", null,
                    React.createElement(TdKey, null, writtenDown
                        ? lang.economy.originalAmount
                        : lang.economy.amount),
                    React.createElement(TdValue, null, caseVoucher.category === VoucherCategory.TRANSACTION ||
                        [
                            VoucherTypeSetting.CompoundInterest,
                            VoucherTypeSetting.InterestPercentage,
                            VoucherTypeSetting.InterestFromTable,
                        ].includes(caseVoucher.setting) ? (React.createElement("b", null,
                        React.createElement(Money, { amount: enteredAmount(caseVoucher) }))) : (React.createElement(EditHandler, { singleCase: singleCase, placeholder: lang.economy.amount, editKey: "amount", editType: EditType.Money, caseVoucher: caseVoucher, preProcessValue: () => enteredAmount(caseVoucher), notNullable: true, validate: (value) => {
                            if (Number.isNaN(value) || typeof value !== 'number') {
                                throw new Error('Amount not a number');
                            }
                            if (value > 0) {
                                throw new Error('Amount must be less than 0');
                            }
                        } },
                        React.createElement("b", null,
                            React.createElement(Money, { amount: enteredAmount(caseVoucher) }))))))),
                writtenDown && (React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.amountAfterWriteOffs),
                    React.createElement(TdValue, null,
                        React.createElement("b", null,
                            React.createElement(Money, { amount: caseVoucher.amount }))))),
                React.createElement(AmountRow, { label: lang.economy.expiredAmount, amount: caseVoucher.expiredAmount }),
                React.createElement(AmountRow, { label: lang.economy.irrecoverableAmount, amount: caseVoucher.irrecoverableAmount }),
                React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.voucherInfoAppendix),
                    React.createElement(TdValue, null, updateAppendix.isLoading ? (React.createElement(PlaceholderLoader, null)) : caseVoucher.appendix ? (React.createElement(File, { file: caseVoucher.appendix, onRemove: () => updateAppendix.mutate(null), removable: true })) : (React.createElement(Button
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        onClick: () => dropzoneRef.current?.open(), theme: "secondary", size: "small" }, lang.economy.addAppendix))))),
            React.createElement("hr", null),
            React.createElement("h3", null, lang.economy.caseVoucherInfoHeaderMeta),
            React.createElement(Table, { zebra: true },
                caseVoucher.createdAt && (React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.caseVoucherInfoCreatedAt),
                    React.createElement(TdValue, null,
                        React.createElement("b", null, moment(caseVoucher.createdAt).format(THEME.DATE_FORMAT_LONG))))),
                shouldShowPerformedBy(site, caseVoucher.createdBy) && (React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.voucherInfoCreatedBy),
                    React.createElement(TdValue, null,
                        React.createElement("b", null,
                            React.createElement(PerformedBy, { performedBy: caseVoucher.createdBy }))))),
                caseVoucher.category && (React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.caseVoucherInfoCategory),
                    React.createElement(TdValue, null,
                        React.createElement("b", null, lang.economyCategories[caseVoucher.category] || caseVoucher.category)))),
                site === Site.Caseworker &&
                    caseVoucher &&
                    // Engine 2 has no date for debt paid before it could expire, but
                    // one can still be pinned; calculated interest has no own date.
                    (caseVoucher.expirationDate ||
                        (engineV2 && !isCalculatedInterest(caseVoucher))) &&
                    [
                        VoucherCategory.COST,
                        VoucherCategory.COURTCOST,
                        VoucherCategory.PRINCIPAL,
                        VoucherCategory.INTEREST,
                    ].includes(caseVoucher.category) && (React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.expirationDate),
                    React.createElement(TdValue, null,
                        React.createElement(EditHandler, { singleCase: singleCase, placeholder: lang.economy.expirationDate, editKey: "expirationDate", editType: EditType.Date, caseVoucher: caseVoucher, notNullable: true, alsoSet: { expirationManualSet: true } },
                            React.createElement("b", null, caseVoucher.expirationDate == null
                                ? '-'
                                : moment(caseVoucher.expirationDate).format(THEME.DATE_FORMAT_SHORT)),
                            caseVoucher.expirationManualSet &&
                                ` (${lang.economy.expirationManualSet})`)))),
                site === Site.Caseworker &&
                    caseVoucher &&
                    [
                        VoucherCategory.COST,
                        VoucherCategory.COURTCOST,
                        VoucherCategory.PRINCIPAL,
                        VoucherCategory.INTEREST,
                    ].includes(caseVoucher.category) && (React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.expirationFromDate),
                    React.createElement(TdValue, null,
                        React.createElement(EditHandler, { singleCase: singleCase, placeholder: lang.economy.expirationFromDate, editKey: "expirationFromDate", editType: EditType.Date, caseVoucher: caseVoucher, notNullable: true },
                            React.createElement("b", null, caseVoucher.expirationFromDate &&
                                moment(caseVoucher.expirationFromDate).format(THEME.DATE_FORMAT_SHORT)))))),
                React.createElement(ReferenceCaseVoucherRow, { caseVoucher: caseVoucher, caseVouchers: caseVouchers }),
                !!caseVoucher.transactionAccountId && (React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.account),
                    React.createElement(TdValue, null,
                        React.createElement("b", null,
                            React.createElement(TransactionAccountPreview, { transactionAccountId: caseVoucher.transactionAccountId }))))),
                !!caseVoucher.transactionImportId && (React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.depositFile),
                    React.createElement(TdValue, null,
                        React.createElement("b", null,
                            React.createElement(TransactionImportPreview, { transactionImportId: caseVoucher.transactionImportId }))))),
                caseVoucher.caseId && (React.createElement(CaseRow, { caseVoucher: caseVoucher, singleCase: singleCase })),
                caseVoucher.caseId && tenant?.type === TenantType.Agency && (React.createElement("tr", null,
                    React.createElement(TdKey, null, lang.economy.voucherInfoCreditorName),
                    React.createElement(TdValue, null,
                        React.createElement("b", null,
                            React.createElement(CreditorNameByCaseId, { caseId: caseVoucher.caseId })))))),
            caseVoucher.category === VoucherCategory.INTEREST && (React.createElement(React.Fragment, null,
                React.createElement("hr", null),
                React.createElement("h3", null, lang.economy.caseVoucherInfoHeaderInterest),
                React.createElement(Table, { zebra: true },
                    ([
                        VoucherTypeSetting.InterestPercentage,
                        VoucherTypeSetting.CompoundInterest,
                    ].includes(caseVoucher.setting) ||
                        caseVoucher.voucherTypeId === VoucherTypeIds.FIXEDINTEREST) && (React.createElement("tr", null,
                        React.createElement(TdKey, null, lang.economy.interestRate),
                        React.createElement(TdValue, null,
                            React.createElement(EditHandler, { singleCase: singleCase, placeholder: lang.economy.interest, editKey: "interest", editType: EditType.Number, caseVoucher: caseVoucher, notNullable: true, preProcessValue: (value) => value * 100, postProcessValue: (value) => value / 100 },
                                React.createElement("b", null,
                                    typeof caseVoucher.interest === 'number' ? (formatNumber(toPercent(caseVoucher.interest) * 100)) : (React.createElement(RenderNull, null)),
                                    ' ',
                                    "%"))))),
                    caseVoucher.category === VoucherCategory.INTEREST && (React.createElement("tr", null,
                        React.createElement(TdKey, null, lang.economy.interestStartDate),
                        React.createElement(TdValue, null,
                            React.createElement(EditHandler, { singleCase: singleCase, placeholder: lang.economy.interestStartDate, editKey: "interestStartDate", editType: EditType.Date, caseVoucher: caseVoucher, notNullable: true, minDate: referencingCaseVoucher?.date
                                    ? new Date(referencingCaseVoucher?.date)
                                    : undefined, onSave: (date) => caseVouchersAPI.patchCaseVoucher(caseVoucher.caseVoucherId, {
                                    date,
                                }) },
                                React.createElement("b", null, moment(caseVoucher.interestStartDate).format(THEME.DATE_FORMAT_SHORT)))))),
                    caseVoucher.category === VoucherCategory.INTEREST && (React.createElement("tr", null,
                        React.createElement(TdKey, null, lang.economy.interestEndDate),
                        React.createElement(TdValue, null,
                            React.createElement(EditHandler, { singleCase: singleCase, placeholder: lang.economy.interestEndDate, editKey: "interestEndDate", editType: EditType.Date, caseVoucher: caseVoucher, minDate: caseVoucher.interestStartDate
                                    ? new Date(caseVoucher.interestStartDate)
                                    : undefined },
                                React.createElement("b", null, caseVoucher.interestEndDate ? (moment(caseVoucher.interestEndDate).format(THEME.DATE_FORMAT_SHORT)) : (React.createElement(RenderNull, null))))))),
                    caseVoucher.interestPeriods != null &&
                        caseVoucher.interestPeriods.length > 0 && (React.createElement("tr", null,
                        React.createElement(TdKey, null, lang.economy.voucherInfoInterestPeriods),
                        React.createElement(TdValue, null, caseVoucher.interestPeriods.map((period) => (React.createElement("div", { key: period.id },
                            React.createElement("b", null,
                                moment(period.from).format(THEME.DATE_FORMAT_SHORT),
                                ' - ',
                                period.to !== null
                                    ? moment(period.to).format(THEME.DATE_FORMAT_SHORT)
                                    : lang.economy.voucherInfoInterestPeriodOpenEnded),
                            ' ',
                            period.rate === 0
                                ? lang.economy.voucherInfoInterestPeriodFrozen
                                : `${formatNumber(toPercent(period.rate) * 100)} %`,
                            period.voidedAt !== null && (React.createElement(React.Fragment, null,
                                ' ',
                                "(",
                                lang.economy.voucherInfoInterestPeriodVoided,
                                ' ',
                                moment(period.voidedAt).format(THEME.DATE_FORMAT_SHORT),
                                ")")))))))))))),
        React.createElement("hr", null),
        React.createElement("h3", null, lang.properties.properties),
        React.createElement(Properties, { caseGroupId: singleCase?.caseGroup?.id ?? null, editable: true, propRef: Entity.CaseVoucher, propRefId: caseVoucher.caseVoucherId })));
};
const AmountRow = (props) => props.amount == null || props.amount === 0 ? null : (React.createElement("tr", null,
    React.createElement(TdKey, null, props.label),
    React.createElement(TdValue, null,
        React.createElement("b", null,
            React.createElement(Money, { amount: props.amount })))));
export default CaseVoucherInfoMeta;
const patchCaseVoucher = async (caseVoucherId, _patch, lang, site, caseId) => {
    const patch = (preventAdjustments) => caseVouchersAPI.patchCaseVoucher(caseVoucherId, _patch, {
        preventAdjustments: preventAdjustments,
    });
    try {
        await patch(true);
    }
    catch (error) {
        if (
        // @ts-ignore
        error?.message?.indexOf(ErrorYouAreAboutToMakePossibleUnintendedAdjustments) !== -1) {
            if (confirm(lang.billing.warnThisWillAffectBilling)) {
                await patch(false);
            }
        }
        else {
            throw error;
        }
    }
    if (caseId) {
        q.invalidate(keys.write.modify(caseVouchersEntity, caseVoucherId));
        q.invalidate(keys.write.create(blameLogsEntity));
    }
};
const Meta = styled.div `
  margin-bottom: 20px;
`;
var EditType;
(function (EditType) {
    EditType[EditType["String"] = 0] = "String";
    EditType[EditType["Date"] = 1] = "Date";
    EditType[EditType["Number"] = 2] = "Number";
    EditType[EditType["Money"] = 3] = "Money";
})(EditType || (EditType = {}));
const EditHandler = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const value = props.preProcessValue
        ? props.preProcessValue(props.caseVoucher[props.editKey])
        : props.caseVoucher[props.editKey];
    const [edit, setEdit] = useState(false);
    const [editString, setEditString] = useState(props.editType === EditType.String ? value : null);
    const [editDate] = useState(props.editType === EditType.Date ? moment(value || undefined) : null);
    const [editNumber, setEditNumber] = useState(props.editType === EditType.Number ? value : null);
    const [editMoney, setEditMoney] = useState(props.editType === EditType.Money ? value : null);
    const [loading, setLoading] = useState(false);
    const save = async (value) => {
        if (props.notNullable && !value) {
            return false;
        }
        setLoading(true);
        try {
            if (props.postProcessValue) {
                value = props.postProcessValue(value);
            }
            if (props.validate) {
                props.validate(value);
            }
            await patchCaseVoucher(props.caseVoucher.caseVoucherId, {
                [props.editKey]: value,
                ...props.alsoSet,
            }, lang, site, props.caseVoucher.caseId);
            if (props.onSave) {
                await props.onSave(value);
            }
        }
        catch (error) {
            console.error(error);
            errorNotification(lang, error, 'update', lang.errorEntities.caseVoucher);
        }
        setLoading(false);
        setEdit(false);
        return true;
    };
    const changeHandler = (value, onchange) => {
        if (props.onChange) {
            props.onChange(value);
        }
        onchange();
    };
    const editable = site === Site.Caseworker ||
        (site === Site.Client && props.singleCase?.status === CaseStatus.PENDING);
    return (React.createElement(React.Fragment, null, loading ? (React.createElement(PlaceholderLoader, null)) : edit ? (React.createElement(React.Fragment, null, (() => {
        switch (props.editType) {
            case EditType.String:
                return (React.createElement(Input, { autofocus: true, style: {
                        marginBottom: '0px',
                    }, placeholder: props.placeholder, value: editString, onChange: (e) => {
                        changeHandler(e.target.value, () => {
                            setEditString(e.target.value);
                        });
                    }, onSubmit: () => {
                        save(editString || null);
                    } }));
            case EditType.Date:
                return (React.createElement(DateInput, { allowNull: !props.notNullable ? true : undefined, style: {
                        marginBottom: '0px',
                    }, placeholder: props.placeholder, value: editDate, onChange: (date) => {
                        save(date ? date.format() : null);
                    }, minDate: props.minDate }));
            case EditType.Number:
                return (React.createElement(Input, { type: "number", autofocus: true, style: {
                        marginBottom: '0px',
                    }, placeholder: props.placeholder, value: editNumber || '', onChange: (e) => setEditNumber(e.target.value), onSubmit: (value) => {
                        save(value || null);
                    } }));
            case EditType.Money:
                return (React.createElement(MoneyInput, { autofocus: true, placeholder: props.placeholder, value: editMoney, onChange: (amount) => setEditMoney(amount), allowNull: !props.notNullable, onKeyDown: (e) => {
                        if (e.key === 'Enter') {
                            save(editMoney);
                        }
                    }, button: {
                        value: lang.inputs.save,
                        onClick: () => {
                            save(editMoney);
                        },
                        theme: 'primary',
                    } }));
            default:
                return null;
        }
    })())) : (React.createElement(React.Fragment, null,
        props.children,
        editable &&
            props.caseVoucher.category !== VoucherCategory.TRANSACTION && (React.createElement(Edit, { onClick: () => setEdit(!edit), style: {
                cursor: 'pointer',
                float: 'right',
            } }))))));
};
const CreditorNameByCaseId = (props) => {
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    return creditor ? React.createElement(React.Fragment, null, creditor.name) : null;
};
const TdKey = styled.td `
  width: 35%;
`;
const TdValue = styled.td ``;
const CaseRow = (props) => {
    const { caseVoucher } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [editCaseId, setEditCaseId] = useState(false);
    const moveToCase = useMutation(async (item) => {
        if (item.id === caseVoucher.caseId || typeof item.id !== 'string') {
            throw new Error('Invalid caseId');
        }
        await patchCaseVoucher(caseVoucher.caseVoucherId, {
            referenceCaseVoucherId: null,
            caseId: item.id,
        }, lang, site, caseVoucher.caseId);
        // handle reference vouchers
        if (caseVoucher.children?.length) {
            for (let i = 0; i < caseVoucher.children.length; i++) {
                const child = caseVoucher.children[i];
                await patchCaseVoucher(child.caseVoucherId, {
                    caseId: item.id,
                }, lang, site);
            }
        }
    }, {
        onError: (error) => {
            errorNotification(lang, error, 'update', lang.errorEntities.caseVoucher, getErrorMessage(error)?.includes(ErrorCannotMoveWrittenOffVoucher) ===
                true
                ? lang.economy.cannotMoveWrittenOffVoucher
                : undefined);
        },
    });
    if (!caseVoucher.caseId) {
        return null;
    }
    return (React.createElement("tr", null,
        React.createElement(TdKey, null, lang.economy.voucherInfoCasePreview),
        React.createElement(TdValue, null,
            !editCaseId && (React.createElement(Edit, { onClick: () => setEditCaseId(!editCaseId), style: {
                    cursor: 'pointer',
                    float: 'right',
                } })),
            editCaseId ? (moveToCase.isLoading ? (React.createElement(PlaceholderLoader, null)) : (React.createElement(Search, { removeWrapper: true, onSelect: (item) => moveToCase.mutate(item), entity: Entity.Case }))) : (React.createElement(CasePreviewByCaseId, { caseId: caseVoucher.caseId })))));
};
const ReferenceCaseVoucherRow = (props) => {
    const { caseVoucher, caseVouchers } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [editReferenceVoucher, setEditReferenceVoucher] = useState(false);
    const updateReferenceVoucher = useMutation((referenceCaseVoucherId) => patchCaseVoucher(caseVoucher.caseVoucherId, {
        referenceCaseVoucherId,
    }, lang, site, caseVoucher.caseId), {
        onError: (error) => {
            console.error(error);
            errorNotification(lang, error, 'update', lang.errorEntities.caseVoucher);
        },
    });
    const referencingCaseVoucher = caseVouchers && caseVoucher.referenceCaseVoucherId
        ? caseVouchers.find((v) => v.caseVoucherId === caseVoucher.referenceCaseVoucherId)
        : null;
    const hasReferenceVouchers = !!caseVoucher.children?.length;
    return (React.createElement(React.Fragment, null, referencingCaseVoucher ? (React.createElement("tr", null,
        React.createElement(TdKey, null, lang.economy.voucherInfoRefVoucher),
        React.createElement(TdValue, null,
            (!caseVoucher.setting ||
                ![
                    VoucherTypeSetting.InterestFromTable,
                    VoucherTypeSetting.InterestPercentage,
                    VoucherTypeSetting.CompoundInterest,
                ].includes(caseVoucher.setting)) && (React.createElement(X, { style: { float: 'right', cursor: 'pointer' }, onClick: () => updateReferenceVoucher.mutate(null) })),
            React.createElement("span", { style: { width: '100px', display: 'inline-block' } },
                lang.economy.caseVoucherInfoType,
                ":"),
            ' ',
            React.createElement("b", null, lang.economyVoucherTypeLabels[referencingCaseVoucher.voucherTypeId] || referencingCaseVoucher.label),
            React.createElement("br", null),
            React.createElement("span", { style: { width: '100px', display: 'inline-block' } },
                lang.economy.amount,
                ":"),
            ' ',
            React.createElement("b", null,
                React.createElement(Money, { amount: referencingCaseVoucher.amount })),
            React.createElement("br", null),
            React.createElement("span", { style: { width: '100px', display: 'inline-block' } },
                lang.economy.date,
                ":"),
            ' ',
            React.createElement("b", null, moment(referencingCaseVoucher.date).format(THEME.DATE_FORMAT_SHORT)),
            referencingCaseVoucher.dueDate && (React.createElement(React.Fragment, null,
                React.createElement("br", null),
                React.createElement("span", { style: { width: '100px', display: 'inline-block' } },
                    lang.economy.dueDate,
                    ":"),
                ' ',
                React.createElement("b", null, moment(referencingCaseVoucher.dueDate).format(THEME.DATE_FORMAT_SHORT))))))) : (!hasReferenceVouchers && (React.createElement("tr", null,
        React.createElement(TdKey, null, lang.economy.voucherInfoRefVoucher),
        React.createElement(TdValue, null,
            !editReferenceVoucher && (React.createElement(Edit, { onClick: () => setEditReferenceVoucher(!editReferenceVoucher), style: {
                    cursor: 'pointer',
                    float: 'right',
                } })),
            editReferenceVoucher &&
                (updateReferenceVoucher.isLoading ? (React.createElement(PlaceholderLoader, null)) : (React.createElement(SearchInput, { onSelect: (caseVoucherId) => updateReferenceVoucher.mutate(caseVoucherId), searchDelay: 0, forceOpen: true, placeholder: lang.economy.selectReferenceVoucher, searchAll: (q) => (caseVouchers || [])
                        .map((cV) => ({
                        heading: `${
                        // @ts-ignore
                        lang.economyVoucherTypeLabels[cV.voucherTypeId] ||
                            cV.label} ${cV.referenceId || ''}`,
                        subheading: lang.economyCategories[cV.category],
                        key: cV.caseVoucherId,
                        returnData: cV.caseVoucherId,
                    }))
                        .filter((cV) => {
                        if (cV.returnData === caseVoucher.caseVoucherId) {
                            return false;
                        }
                        return (!q ||
                            JSON.stringify(cV)
                                .toLowerCase()
                                .includes(q.toLowerCase()));
                    }) })))))))));
};
//# sourceMappingURL=CaseVoucherInfoMeta.js.map